import type { AggregationMode } from "./trendingUrlState";

export interface EnvelopeBucket {
	avg: [number, number | null];
	min: [number, number | null];
	max: [number, number | null];
}

export const reduceEnvelopeBucket = (
	data: [number, number | null][],
	startIdx: number,
	endIdx: number,
): EnvelopeBucket => {
	let sum = 0;
	let count = 0;
	let minValue = 0;
	let maxValue = 0;

	for (let i = startIdx; i <= endIdx; i++) {
		const value = data[i][1];
		if (value === null || value === undefined) {
			continue;
		}

		if (count === 0) {
			minValue = value;
			maxValue = value;
		} else {
			if (value < minValue) minValue = value;
			if (value > maxValue) maxValue = value;
		}

		sum += value;
		count++;
	}

	const timestamp = (data[startIdx][0] + data[endIdx][0]) / 2;

	if (count === 0) {
		return {
			avg: [timestamp, null],
			min: [timestamp, null],
			max: [timestamp, null],
		};
	}

	return {
		avg: [timestamp, sum / count],
		min: [timestamp, minValue],
		max: [timestamp, maxValue],
	};
};

export const reduceBucket = (
	data: [number, number | null][],
	startIdx: number,
	endIdx: number,
	mode: AggregationMode,
): [number, number | null] => {
	let firstIdx = -1;
	let lastIdx = -1;
	let minIdx = -1;
	let maxIdx = -1;
	let sum = 0;
	let count = 0;

	for (let i = startIdx; i <= endIdx; i++) {
		const value = data[i][1];
		if (value === null || value === undefined) {
			continue;
		}

		if (firstIdx === -1) {
			firstIdx = i;
		}
		lastIdx = i;
		sum += value;
		count++;

		if (minIdx === -1 || value < (data[minIdx][1] as number)) {
			minIdx = i;
		}
		if (maxIdx === -1 || value > (data[maxIdx][1] as number)) {
			maxIdx = i;
		}
	}

	if (count === 0) {
		return data[startIdx];
	}

	switch (mode) {
		case "first":
			return [data[endIdx][0], data[firstIdx][1]];
		case "last":
			return data[lastIdx];
		case "min":
			return [data[endIdx][0], data[minIdx][1]];
		case "max":
			return [data[endIdx][0], data[maxIdx][1]];
		default:
			return [(data[startIdx][0] + data[endIdx][0]) / 2, sum / count];
	}
};
